export default class PaansCheckResponse {
  constructor(obj) {
    if (!obj) obj = {};
    this.hasAccepted = obj.hasAccepted ? obj.hasAccepted : false;
    this.mustReadToEnd = obj.mustReadToEnd ? obj.mustReadToEnd : false;
    this.redirectUrl = obj.redirectUrl ? obj.redirectUrl : false;
  }
}
